/**
 * תמונות אווירה ליעד חיפוש (סיכום חי / טיסות) — מאחד עם SSOT טיול מאורגן (`organizedTourHeroResolver`).
 */
import { primaryLocation } from "./flightSearchDisplayAdapter";
import { resolveOrganizedTourHeroVisual } from "../../../utils/organizedTourHeroResolver";

/**
 * @returns {{ src: string, headline: string }}
 */
export function getDestinationHeroVisual(location, destinationLabel) {
  const dest = primaryLocation(location);
  const rawLabel = String(destinationLabel || "").trim();
  const label = rawLabel && rawLabel !== "—" ? rawLabel : "יעד החיפוש";

  const code = String(dest?.AIRPORTCODE || dest?.CITYCODE || dest?.code || "")
    .trim()
    .toUpperCase()
    .match(/^([A-Z]{3})/)?.[1] ||
    "";

  const codes = [];
  if (code) codes.push(code);

  const blob = [
    rawLabel,
    dest?.CITYNAME,
    dest?.AIRPORTNAME,
    dest?.name,
    code,
  ]
    .filter(Boolean)
    .join(" ");

  const hero = resolveOrganizedTourHeroVisual({
    airportCodes: codes.length ? codes : [],
    semanticBlob: blob || rawLabel || label,
  });

  return { src: hero.url, headline: label };
}
